export default __webpack_public_path__ + "static/media/billreynolds_red_earth.c4083cdc.jpg";